const getLangFromPathname = () => {
  const { pathname } = window.location;
  return pathname.split(/^\/([\w]{2})\//g)[1];
}

export default getLangFromPathname;